module.exports = __webpack_public_path__ + "img/banner_generic_top.8a845ff8.jpg";